import { marked } from 'marked';
import markedLinkifyIt from 'marked-linkify-it';
import anchor from './anchor';
import { phoneNumbers } from './phoneNumber';

export default function convertToHtml(content: string, inline = false): string {
  const renderer = new marked.Renderer();

  const schemas = phoneNumbers.reduce(
    (acc, { prefix, options }) => Object.assign(acc, { [prefix]: options }),
    {},
  );

  marked.use(markedLinkifyIt({ schemas }));
  renderer.link = function (href, _, text) {
    return anchor(href, text);
  };

  marked.setOptions({
    renderer,
    headerIds: true,
    mangle: false,
  });

  const cleanedContent = content.replaceAll('‑', '-');

  const result = inline
    ? marked.parseInline(cleanedContent)
    : marked(cleanedContent);

  return result.trim();
}
